const shadows = {
    lg: '1px 1px 30px rgba(26, 26, 26, 0.2)',
    sm: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    xs: '0px 1px 2px rgba(26, 26, 26, 0.1)',
};

export default shadows;
